class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static freeshipPrice = parseInt(window.free_shipping_price);

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));
        // The theme announces every cart refresh on document; the bar must follow even when it is not re-rendered.
        this.onDocumentCartUpdate = () => this.initialize();
        document.addEventListener('cart-update', this.onDocumentCartUpdate);

        this.initialize();
    }

    disconnectedCallback() {
        document.removeEventListener('cart-update', this.onDocumentCartUpdate);
    }

    // Read the cart uncached, and apply only the newest answer: an older response arriving late used to leave
    // the bar on the previous total after an add or a quantity change.
    initialize() {
        const seq = (this.requestSeq = (this.requestSeq || 0) + 1);
        fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => {
                if (seq !== this.requestSeq) return;
                this.cart = cart;
                this.calculateProgress(cart);
            })
            .catch(() => {});
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
        // The cart is in the shopper's currency; the threshold and the flat charge are set in the shop's (USD).
        // Checkout converts its $150 / $50 with the same rate, so the bar does too.
        const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        const totalCents = parseInt(cart.total_price);
        const thresholdCents = Math.round(FreeShippingMeter.freeshipPrice * rate * 100);
        const feeCents = Math.round((window.lts_flat_shipping || 0) * rate * 100);

        let freeShipBar = thresholdCents > 0 ? Math.abs((totalCents * 100) / thresholdCents) : 100;
        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }

        const text = window.free_shipping_text.lts_under
            ? this.getFlatText(totalCents, thresholdCents, feeCents)
            : this.getText((totalCents / 100).toFixed(2), freeShipBar);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    // Leather Top Shop rule (2026-10-15): a flat charge per order below the threshold, free at or above it.
    getFlatText(totalCents, thresholdCents, feeCents) {
        const money = (cents) => Shopify.formatMoney(cents, window.money_format);
        const fill = (s) => s.split('[threshold]').join(money(thresholdCents))
            .split('[fee]').join(money(feeCents))
            .split('[remaining]').join(money(Math.max(thresholdCents - totalCents, 0)));

        if (totalCents <= 0) {
            this.progressBar.classList.add('progress-hidden');
            return '<span>' + fill(window.free_shipping_text.lts_empty) + '</span>';
        }
        this.progressBar.classList.remove('progress-hidden');
        if (totalCents >= thresholdCents) {
            this.freeShippingEligible = 1;
            return '<span>' + fill(window.free_shipping_text.lts_free) + '</span>';
        }
        this.freeShippingEligible = 0;
        return '<span>' + fill(window.free_shipping_text.lts_under) + '</span>';
    }

    getText(cartTotalPrice, freeShipBar) {
        let text;

        if (cartTotalPrice == 0) {
            this.progressBar.classList.add('progress-hidden');
            text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +'!</span>';
        } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text = FreeShippingMeter.freeShippingText1;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingPrice = Math.abs(FreeShippingMeter.freeshipPrice - cartTotalPrice);
            text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            this.shipVal = window.free_shipping_text.free_shipping_2;
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            this.resetProgressClass(classLabel);

            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                const textWrapper = this.progressMeter.querySelector('.text').innerHTML = `${freeShipBar.toFixed(2)}%`;
            }

            this.messageElement.innerHTML = text;

            if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})